import { render, staticRenderFns } from "./NsSlottedDropdownModal.vue?vue&type=template&id=723f9d64&scoped=true&"
import script from "./NsSlottedDropdownModal.vue?vue&type=script&lang=js&"
export * from "./NsSlottedDropdownModal.vue?vue&type=script&lang=js&"
import style0 from "./NsSlottedDropdownModal.vue?vue&type=style&index=0&id=723f9d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f9d64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
